module.exports = __webpack_public_path__ + "static/img/save.1ed3bf9e.svg";